module.exports = __webpack_public_path__ + "img/credenza-360px.554ea6cd.png";